//#region Dependencies
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import { StandardSelectModal, StandardTable, WarningModal } from "../index";
import { ApiClient } from "../../libs/apiClient";
import $ from "jquery";
let apiClient = ApiClient.getInstance();
//#endregion

export default function MassiveUsersModal(props) {
    //#region REDUX
    const dispatch = useDispatch();
    const notificationReducer = useSelector((store) => store.NotificationReducer);
    const { showAlert } = notificationReducer;
    const enableSpinner = (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value });
    //#endregion

    //#region Variables && Const Declaration
    const [userRef, setUserRef] = useState({ UserID: 4, UserName: "RAYME CASTILLO NILTON JHON" });
    const [userRefList, setUserRefList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [processFlag, setProcessFlag] = useState(false);
    //#endregion

    //#region Actions
    useEffect(() => {
        if (Array.isArray(props.users)) { setUserList(props.users); }
    }, []);

    useEffect(() => {
        if (!!userRefList.length) {
            $("#UsersRefListModal").modal("show"); 
            $("#UsersRefListModal").on("hidden.bs.modal", () => setUserRefList([]));
        }
    }, [userRefList]);

    const close = () => {
        $("#MassiveUsersModal").modal("hide");
    };

    const create = async () => {
        setProcessFlag(true);
        const processList = userList.filter(({ Status }) => Status !== 1);
        if (processList.length) {
            for (const user of processList) {
                enableSpinner(true);
                const apiResponse = await apiClient.post("createMassiveUser", { user, userRef });
                enableSpinner(false);
                
                user.Status = apiResponse.status;
                user.Error = apiResponse.message;

                setUserList((prev) => {
                    const newList = prev.map((u) => u.DNI === user.DNI ? user : u);
                    return newList;
                });
            }
        } else { showAlert({ type: "info", message: "No hay usuarios para procesar" }); }
        setProcessFlag(false);
    };

    const openUsersRefList = async () => {
        enableSpinner(true);
        const usersResponse = await apiClient.get("branchUsers");
        enableSpinner(false);

        if (usersResponse.status !== SERVICE_RESPONSE.SUCCESS) { return showAlert({ type: "error", message: "No se pudieron cargar los usuarios, intente de nuevo" }); }
        setUserRefList(Array.isArray(usersResponse.data) ? usersResponse.data : []);
    }

    const selectUserRef = (user) => {
        setUserRef(user);
        $("#UsersRefListModal").modal("hide");
    }
    //#endregion

    //#region Render
    const formatStatus = (_, data) => {
        switch (data.Status) {
            case 1: return <span className="badge badge-success"> Creado </span>;
            case 0: return <span className="badge badge-danger"> Error: {data.Error || "Error desconocido"} </span>;
            default: return <span className="badge badge-secondary"> Por procesar </span>;
        }
    };

    return (
        <>
            <div id="MassiveUsersModal" className="modal fade" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-dark text-white">
                            <span className="h5"> Creación de Usuarios </span>
                            <button type="button" className="close" onClick={close}> &times; </button>
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <label className="input-group-text font-weight-bold" htmlFor="inUserRef"> Usuario BASE </label>
                                        </div>
                                        <input className="form-control" disabled readOnly value={userRef.UserName ?? ""} />
                                        <button id="inUserRef" type="button" className="btn btn-outline-warning" onClick={openUsersRefList}> <i className="fa fa-list"/> </button>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label className="h6"> Usuarios por Crear </label>
                                    <hr className="w-100"/>
                                    
                                    <div className="w-100 p-3" style={{ maxHeight: 300, overflow: "auto" }}>
                                        <StandardTable
                                            headers={[
                                                { title: "Código", active: true, field: "DNI" },
                                                { title: "Correo", active: true, field: "CORREO" },
                                                { title: "Estado", active: true, field: "Status", format: formatStatus },
                                            ]}
                                            data={userList}
                                            searchBarSize="none"
                                            paginated={false} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {!processFlag && (<button type="button" className="btn btn-warning" onClick={() => $("#warningModal").modal("show")}> Crear </button>)}
                            <button type="button" className="btn btn-dark" onClick={close}> Cerrar </button>
                        </div>
                    </div>
                </div>
            </div>

            <WarningModal
                title="Confirmación"
                message="Esta acción creara nuevos usuarios para BRANCH, ¿Seguro que deasea continuar?"
                btnAccept="Continuar"
                btnCancel="Cancelar"
                accept={create}
                cancel={() => $("#warningModal").modal("hide")} />

            {(!!userRefList.length) && (
                <StandardSelectModal
                    id="UsersRefListModal"
                    title={"Lista de Usuarios"}
                    headers={[
                        { title: "Usuario", value: true, filter: true, field: "UserCode" },
                        { title: "Nombre", value: true, filter: true, field: "UserName" },
                        { title: "Correo", value: true, filter: true, field: "EMail" },
                    ]}
                    data={userRefList}
                    selectAction={selectUserRef} />
            )}
        </>
    );
    //#endregion
}